import React, { Component } from 'react'
import { injectIntl, defineMessages } from 'react-intl'
import Select from 'react-select'
import { AppContext, Features } from '@lightspeed-invoicing/core-client/frontend'

const messages = defineMessages({
    "placeholder": {
        id: 'common.calendar.select.placeholder',
        defaultMessage: 'Select a calendar',
    },
    "no_active_calendar": {
        id: 'common.calendar.no_active_calendar',
        defaultMessage: 'No active calendar found',
    },
})

class CalendarSelect extends Component {

    constructor(props, context) {
        super(props, context)
        const isMulti = !isNaN(this.props.multi) ? this.props.multi : true
        this.state = {
            initialOptions: [],
            options: [],
            selectedOptions: this.props.value || (isMulti ? [] : ''),
            multi: isMulti,
            onePerExternalAccount: this.props.onePerExternalAccount || false,
            disabled: this.props.disabled || false,
        }

        const defaultCallback = () => { }
        this.name = this.props.name || 'calendar-select'
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(selectedOptions) {
        this.setState({
            selectedOptions: selectedOptions,
        }, () => {
            if (Array.isArray(selectedOptions) && selectedOptions.length > 0) {
                this.onChange(selectedOptions.map(s => s.value), selectedOptions.map(s => s.label), selectedOptions.map(s => s.calendar))
            } else if (!Array.isArray(selectedOptions) && selectedOptions) {
                this.onChange(selectedOptions.value, selectedOptions.label, selectedOptions.calendar)
            } else {
                this.onChange([], [])
            }
            if (this.state.onePerExternalAccount) {
                let emails = selectedOptions.map(op => op.email)
                let calendarIds = selectedOptions.map(op => op.value)
                this.setState({
                    options: this.state.initialOptions.filter(calendar => !emails.includes(calendar.email) || calendarIds.includes(calendar.value))
                })
            }
        });
    }

    componentDidMount() {
        this.loadCalendars()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value && nextProps.value.length !== this.state.selectedOptions.length) {
            this.setState({
                selectedOptions: nextProps.value,
            })
        }
    }

    loadCalendars() {
        AppContext.getApiClient().get(`/calendars`)
            .then((res) => {
                if (res.data) {
                    let options = []
                    options = options.concat(
                        res.data.filter(calendar => calendar.attributes.status !== 'inactive' &&
                            ((!this.state.disabled && calendar.attributes.visibility === 'private') ?
                                AppContext.getUserLoggedIn().id === calendar.attributes.userId : true))
                            .map(calendar => {
                                return {
                                    value: calendar.id,
                                    label: `${calendar.attributes.title} (${calendar.attributes.email})`,
                                    email: calendar.attributes.email,
                                    calendar: calendar,
                                }
                            })
                    )
                    this.setState({
                        options: options,
                        initialOptions: options,
                    })
                }
            })
    }

    render() {
        return (
            <Select
                className="calendar-select"
                name={this.name}
                placeholder={(this.state.options.length === 0) ?
                    this.props.intl.formatMessage(messages.no_active_calendar) : (this.placeholder || this.props.intl.formatMessage(messages.placeholder))}
                value={this.state.selectedOptions}
                onChange={this.handleChange}
                options={this.state.options}
                clearable={false}
                searchable={false}
                disabled={this.state.options.length === 0 || this.state.disabled}
                multi={this.state.multi}
            />
        )
    }
}

export default injectIntl(CalendarSelect)





// WEBPACK FOOTER //
// ./src/calendar/calendarselect.component.jsx